import type { ThemeMode } from '../../../theme/websiteTheme';

// Validated categorical order from the dataviz skill's reference palette
// (references/palette.md) — fixed order, never cycled/reordered per-chart.
export const CATEGORICAL: Record<ThemeMode, string[]> = {
  light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'],
  dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'],
};

export const DELTA_UP: Record<ThemeMode, string> = { light: '#006300', dark: '#0ca30c' };
export const DELTA_DOWN: Record<ThemeMode, string> = { light: '#d03b3b', dark: '#d03b3b' };

export const CHART_CHROME: Record<ThemeMode, { gridline: string; axis: string; mutedText: string }> = {
  light: { gridline: '#e1e0d9', axis: '#c3c2b7', mutedText: '#898781' },
  dark: { gridline: '#2c2c2a', axis: '#383835', mutedText: '#898781' },
};

export const categoricalColor = (mode: ThemeMode, index: number): string =>
  CATEGORICAL[mode][index % CATEGORICAL[mode].length];
